export var priceById = function (id, FOR_VK, FOR_YANDEX) {
    if (FOR_VK === void 0) { FOR_VK = false; }
    if (FOR_YANDEX === void 0) { FOR_YANDEX = false; }
    if (FOR_VK) {
        if (id === '1')
            return 2;
        if (id === '2')
            return 4;
        if (id === '3')
            return 6;
        if (id === '101')
            return 1;
        if (id === '102')
            return 2;
        if (id === '103')
            return 3;
    }
    if (FOR_YANDEX) {
        if (id === '1')
            return 2;
        if (id === '2')
            return 4;
        if (id === '3')
            return 6;
        if (id === '101')
            return 1;
        if (id === '102')
            return 2;
        if (id === '103')
            return 3;
    }
    return 0;
};
